import { render } from "./AdminCmsEdit.vue?vue&type=template&id=7cab4ce0&scoped=true&ts=true&lang=true"
import script from "./AdminCmsEdit.vue?vue&type=script&lang=ts"
export * from "./AdminCmsEdit.vue?vue&type=script&lang=ts"

import "./AdminCmsEdit.vue?vue&type=style&index=0&id=7cab4ce0&scoped=true&lang=css"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cab4ce0"]])

export default __exports__